import React from 'react';

import { ClockIcon } from '@ergeon/icons/hero/mini';
import { getReadingMinutes } from '@ergeon/help-components';

import { WikiNode } from '../types';

const NodeHeader = ({ node }: { node: WikiNode }) => (
  <header className="flex flex-col gap-3 border-b border-gray-200 pb-6 dark:border-gray-800">
    <h1 className="wrap-break-word heading-2 text-gray-900 dark:text-white">{node.title}</h1>
    {node.shortMemo && (
      <p className="font-base text-lg leading-7 text-gray-700 dark:text-gray-300">{node.shortMemo}</p>
    )}
    <p className="flex items-center gap-1.5 paragraph-2 text-gray-600 dark:text-gray-400">
      <ClockIcon aria-hidden="true" className="size-4" />
      {`${getReadingMinutes(node.content)} min read`}
    </p>
  </header>
);

export default NodeHeader;
